/** Shopify CDN: Minification failed

Line 14:2 Transforming const to the configured target environment ("es5") is not supported yet
Line 229:65 Expected "}" but found "t"

**/
/* BERLYNCO SKIN ANALYSIS TOOL v2.0 */
(function() {
  'use strict';

  // ============================================================
  // QUIZ QUESTIONS DATABASE
  // ============================================================
  const QUESTIONS = [
    {
      id: 1, dim: 'ST',
      text: 'How does your skin feel a few hours after washing your face?',
      opts: [
        { text: 'Tight, flaky or rough', scores: {ST:'dry',v:3} },
        { text: 'Shiny, oily all over', scores: {ST:'oily',v:3} },
        { text: 'Oily in T-zone, normal elsewhere', scores: {ST:'combo',v:3} },
        { text: 'Comfortable, normal', scores: {ST:'normal',v:3} }
      ]
    },
    {
      id: 6, dim: 'SS',
      text: 'Does your skin turn red or flush easily?',
      opts: [
        { text: 'Yes, very easily and frequently', scores: {SS:'high',v:3} },
        { text: 'Sometimes, with heat or spicy food', scores: {SS:'mod',v:2} },
        { text: 'Rarely or never', scores: {SS:'low',v:1} }
      ]
    },
    {
      id: 7, dim: 'SS',
      text: 'How does your skin react to new skincare products?',
      opts: [
        { text: 'Often burns, stings, or breaks out', scores: {SS:'high',v:3} },
        { text: 'Sometimes mild irritation', scores: {SS:'mod',v:2} },
        { text: 'Usually fine, no reactions', scores: {SS:'low',v:1} }
      ]
    },
    {
      id: 11, dim: 'BH',
      text: 'Does your skin feel rough or look flaky regularly?',
      opts: [
        { text: 'Yes, almost daily', scores: {BH:'damaged',v:3} },
        { text: 'Sometimes', scores: {BH:'compromised',v:2} },
        { text: 'Rarely or never', scores: {BH:'healthy',v:1} }
      ]
    },
    {
      id: 15, dim: 'HL',
      text: 'Does your skin feel dehydrated even when oily?',
      opts: [
        { text: 'Yes, oily but tight underneath', scores: {HL:'poor',v:3} },
        { text: 'Sometimes', scores: {HL:'mod',v:2} },
        { text: 'No, feels balanced', scores: {HL:'good',v:1} }
      ]
    },
    {
      id: 17, dim: 'HL',
      text: 'Do fine lines appear when you smile or move your face?',
      opts: [
        { text: 'Yes, clearly visible', scores: {HL:'poor',v:3} },
        { text: 'Faintly sometimes', scores: {HL:'mod',v:2} },
        { text: 'No, skin looks plump', scores: {HL:'good',v:1} }
      ]
    },
    {
      id: 20, dim: 'TX',
      text: 'How would you describe your skin texture?',
      opts: [
        { text: 'Very rough, bumpy or uneven', scores: {TX:'rough',v:3} },
        { text: 'Mildly uneven with some texture', scores: {TX:'mild',v:2} },
        { text: 'Generally smooth', scores: {TX:'smooth',v:1} }
      ]
    },
    {
      id: 22, dim: 'TX',
      text: 'Do you have acne scars or hyperpigmentation?',
      opts: [
        { text: 'Yes, significant marks or scars', scores: {TX:'rough',v:3} },
        { text: 'Some mild discoloration', scores: {TX:'mild',v:2} },
        { text: 'No or very minimal', scores: {TX:'smooth',v:1} }
      ]
    }
  ];

  // ============================================================
  // SCORING ENGINE
  // ============================================================
  function calculateScores(answers) {
    // ST: pool-based (most votes wins)
    const stPool = {dry:0, oily:0, combo:0, normal:0};
    // SS, BH, HL, TX: threshold-based (accumulate numeric scores)
    const dims = {SS:{high:0,mod:0,low:0}, BH:{healthy:0,compromised:0,damaged:0}, HL:{good:0,mod:0,poor:0}, TX:{smooth:0,mild:0,rough:0}};
    
    answers.forEach(a => {
      const s = a.scores;
      if (s.ST) stPool[s.ST] += s.v;
      if (s.SS) dims.SS[s.SS] += s.v;
      if (s.BH) dims.BH[s.BH] += s.v;
      if (s.HL) dims.HL[s.HL] += s.v;
      if (s.TX) dims.TX[s.TX] += s.v;
    });

    // Determine ST winner
    let st = Object.keys(stPool).reduce((a,b) => stPool[a] >= stPool[b] ? a : b);

    // Determine SS level
    let ss = 'low';
    if (dims.SS.high >= 6) ss = 'high';
    else if (dims.SS.high >= 3 || dims.SS.mod >= 6) ss = 'mod';

    // Determine BH level
    let bh = 'healthy';
    if (dims.BH.damaged >= 6) bh = 'damaged';
    else if (dims.BH.damaged >= 3 || dims.BH.compromised >= 4) bh = 'compromised';

    // Determine HL level
    let hl = 'good';
    if (dims.HL.poor >= 7) hl = 'poor';
    else if (dims.HL.poor >= 4 || dims.HL.mod >= 6) hl = 'mod';

    // Determine TX level
    let tx = 'smooth';
    if (dims.TX.rough >= 7) tx = 'rough';
    else if (dims.TX.rough >= 3 || dims.TX.mild >= 5) tx = 'mild';

    return {st, ss, bh, hl, tx, raw:{stPool, dims}};
  }

  // ============================================================
  // PROFILE ROUTER
  // ============================================================
  function determineProfile(scores) {
    const {st, ss, bh, hl} = scores;

    // P6: Barrier Damaged — overrides all
    if (bh === 'damaged') return 'P6';

    // P1: Dry Sensitive
    if (st === 'dry' && (ss === 'high' || ss === 'mod') && (bh === 'compromised')) return 'P1';
    if (st === 'dry' && ss === 'high') return 'P1';

    // P2: Dry Non-Sensitive
    if (st === 'dry' && ss === 'low') return 'P2';
    if (st === 'dry') return 'P2';

    // P7: Dehydrated (oily/normal/combo with poor hydration)
    if ((st === 'oily' || st === 'normal' || st === 'combo') && bh === 'compromised' && hl === 'poor') return 'P7';

    // P3: Oily Sensitive
    if (st === 'oily' && (ss === 'high' || ss === 'mod') && bh === 'compromised') return 'P3';
    if (st === 'oily' && ss === 'high') return 'P3';

    // P4: Oily Acne-Prone
    if (st === 'oily') return 'P4';

    // P5: Combination Sensitive
    if (st === 'combo' && (ss === 'mod' || ss === 'high')) return 'P5';
    if (st === 'combo' && bh === 'compromised') return 'P5';

    // P8: Normal Skin
    if (st === 'normal' && ss === 'low' && bh === 'healthy') return 'P8';

    // Defaults
    if (st === 'combo') return 'P5';
    if (st === 'normal') return 'P8';

    return 'P8';
  }

  // ============================================================
  // PROFILE DATABASE
  // ============================================================
  const PROFILES = {
    P1: {
      id: 'P1',
      name: 'Dry & Sensitive Skin',
      emoji: '🌸',
      tagline: 'Gentle nourishment your skin craves',
      tags: ['Dry', 'Sensitive', 'Reactive'],
      characteristics: 'Tight, flaky skin that reacts easily to products, weather, and stress. Prone to redness and irritation.',
      morning: [
        { step: 1, action: 'Cleanse', product: 'Derma Calm Gentle Cleanser', why: 'Ultra-mild, pH-balanced, won\'t strip moisture' },
        { step: 2, action: 'Serum', product: 'Barrier Repair Moisturizer (layer thin)', why: 'Lock in hydration early' },
        { step: 3, action: 'Moisturize', product: 'Barrier Repair Moisturizer', why: 'Rich occlusive layer to prevent moisture loss' },
        { step: 4, action: 'SPF', product: 'SPF 20 Hydrating Lotion', why: 'Protect sensitive skin from UV-triggered inflammation' }
      ],
      evening: [
        { step: 1, action: 'Cleanse', product: 'Derma Calm Gentle Cleanser', why: 'Remove impurities without damaging barrier' },
        { step: 2, action: 'Treatment', product: 'Under Eye Repair Serum', why: 'Reduce puffiness and fine lines gently' },
        { step: 3, action: 'Moisturize', product: 'Barrier Repair Moisturizer', why: 'Deep overnight recovery' }
      ],
      lifestyle: ['Avoid hot water — lukewarm only', 'Use fragrance-free laundry detergent', 'Sleep 7-9hrs for skin recovery', 'Patch test all new products'],
      ingredients: ['Ceramides', 'Oat extract', 'Aloe Vera', 'Allantoin', 'Centella Asiatica'],
      products: ['Derma Calm Gentle Cleanser', 'Barrier Repair Moisturizer', 'SPF 20 Hydrating Lotion', 'Under Eye Repair Serum']
    },
    P2: {
      id: 'P2',
      name: 'Dry & Non-Sensitive Skin',
      emoji: '💧',
      tagline: 'Deep hydration without compromise',
      tags: ['Dry', 'Stable', 'Needs Moisture'],
      characteristics: 'Skin that feels tight and looks dull. Tolerates most products well but lacks moisture and glow.',
      morning: [
        { step: 1, action: 'Cleanse', product: 'Hydrating Cream Cleanser', why: 'Creamy formula cleanses while adding moisture' },
        { step: 2, action: 'Serum', product: 'Under Eye Repair Serum', why: 'Boost radiance and reduce dullness' },
        { step: 3, action: 'Moisturize', product: 'Barrier Repair Moisturizer', why: 'Rich hydration to last all day' },
        { step: 4, action: 'SPF', product: 'SPF 20 Hydrating Lotion', why: 'Hydrating SPF seals in moisture' }
      ],
      evening: [
        { step: 1, action: 'Cleanse', product: 'Hydrating Cream Cleanser', why: 'Gentle evening cleanse' },
        { step: 2, action: 'Serum', product: 'Timecode Anti-Ageing Serum', why: 'Stimulate collagen while you sleep' },
        { step: 3, action: 'Moisturize', product: 'Barrier Repair Moisturizer', why: 'Overnight deep moisture repair' }
      ],
      lifestyle: ['Use a humidifier in dry environments', 'Apply moisturizer within 60s of washing', 'Include omega-3 foods in diet', 'Avoid long hot showers'],
      ingredients: ['Hyaluronic Acid', 'Glycerin', 'Shea Butter', 'Squalane', 'Vitamin E'],
      products: ['Hydrating Cream Cleanser', 'Barrier Repair Moisturizer', 'SPF 20 Hydrating Lotion', 'Timecode Anti-Ageing Serum', 'Under Eye Repair Serum']
    },
    P3: {
      id: 'P3',
      name: 'Oily & Sensitive Skin',
      emoji: '⚖️',
      tagline: 'Balance oil without triggering reactions',
      tags: ['Oily', 'Sensitive', 'Reactive'],
      characteristics: 'Excess oil production combined with skin that reacts easily. Prone to breakouts and redness simultaneously.',
      morning: [
        { step: 1, action: 'Cleanse', product: 'Derma Calm Gentle Cleanser', why: 'Control oil gently without causing irritation' },
        { step: 2, action: 'Serum', product: 'Acne & Scar Repair Serum', why: 'Target breakouts without harsh chemicals' },
        { step: 3, action: 'Moisturize', product: 'Barrier Repair Moisturizer', why: 'Lightweight hydration — oily skin needs moisture too' },
        { step: 4, action: 'SPF', product: 'Tinted Sunscreen SPF 50+', why: 'Broad protection without pore-clogging' }
      ],
      evening: [
        { step: 1, action: 'Cleanse', product: 'Derma Calm Gentle Cleanser', why: 'Remove excess oil gently' },
        { step: 2, action: 'Treatment', product: 'Acne & Scar Repair Serum', why: 'Overnight acne treatment' },
        { step: 3, action: 'Moisturize', product: 'Barrier Repair Moisturizer', why: 'Repair and calm overnight' }
      ],
      lifestyle: ['Avoid over-cleansing — max 2x per day', 'Use non-comedogenic products only', 'Manage stress — cortisol increases oil', 'Change pillowcases every 2-3 days'],
      ingredients: ['Niacinamide', 'Centella Asiatica', 'Green Tea Extract', 'Zinc', 'Salicylic Acid (low %)', 'Allantoin'],
      products: ['Derma Calm Gentle Cleanser', 'Acne & Scar Repair Serum', 'Barrier Repair Moisturizer', 'Tinted Sunscreen SPF 50+']
    },
    P4: {
      id: 'P4',
      name: 'Oily & Acne-Prone Skin',
      emoji: '🎯',
      tagline: 'Clear, control and repair your skin',
      tags: ['Oily', 'Acne-Prone', 'Textured'],
      characteristics: 'Consistently oily with frequent breakouts, enlarged pores, and post-acne marks. Needs active treatment.',
      morning: [
        { step: 1, action: 'Cleanse', product: 'Salicylic + Glycolic Face Wash', why: 'Exfoliate and unclog pores at the source' },
        { step: 2, action: 'Serum', product: 'Acne & Scar Repair Serum', why: 'Active acne treatment and scar prevention' },
        { step: 3, action: 'Moisturize', product: 'Barrier Repair Moisturizer', why: 'Lightweight moisture — skip only makes oiliness worse' },
        { step: 4, action: 'SPF', product: 'Tinted Sunscreen SPF 50+', why: 'Prevent PIH (post-inflammatory hyperpigmentation)' }
      ],
      evening: [
        { step: 1, action: 'Cleanse', product: 'Salicylic + Glycolic Face Wash', why: 'Deep cleanse to prevent overnight buildup' },
        { step: 2, action: 'Treatment', product: 'Acne & Scar Repair Serum', why: 'Active repair while skin regenerates overnight' },
        { step: 3, action: 'Moisturize', product: 'Barrier Repair Moisturizer', why: 'Prevent dryness from actives' }
      ],
      lifestyle: ['Avoid touching your face — transfers bacteria', 'Clean phone screen daily', 'Low-glycemic diet reduces breakouts', 'Exfoliate 2-3x weekly maximum'],
      ingredients: ['Salicylic Acid', 'Glycolic Acid', 'Niacinamide', 'Tea Tree', 'Benzoyl Peroxide', 'Retinol (evening)'],
      products: ['Salicylic + Glycolic Face Wash', 'Acne & Scar Repair Serum', 'Barrier Repair Moisturizer', 'Tinted Sunscreen SPF 50+']
    },
    P5: {
      id: 'P5',
      name: 'Combination & Sensitive Skin',
      emoji: '🌿',
      tagline: 'Targeted care for your unique balance',
      tags: ['Combination', 'Sensitive', 'Reactive'],
      characteristics: 'Oily T-zone with dry or normal cheeks, plus sensitivity to many products. Needs zone-specific care.',
      morning: [
        { step: 1, action: 'Cleanse', product: 'Derma Calm Gentle Cleanser', why: 'Gentle enough for sensitive areas' },
        { step: 2, action: 'Serum', product: 'Acne & Scar Repair Serum (T-zone only)', why: 'Control oil in oily zones without over-drying' },
        { step: 3, action: 'Moisturize', product: 'Barrier Repair Moisturizer', why: 'Hydrate dry areas without overloading T-zone' },
        { step: 4, action: 'SPF', product: 'SPF 20 Hydrating Lotion', why: 'Gentle SPF for reactive skin' }
      ],
      evening: [
        { step: 1, action: 'Cleanse', product: 'Derma Calm Gentle Cleanser', why: 'Remove impurities without disrupting balance' },
        { step: 2, action: 'Treatment', product: 'Under Eye Repair Serum', why: 'Sensitive-area focused treatment' },
        { step: 3, action: 'Moisturize', product: 'Barrier Repair Moisturizer', why: 'Overnight barrier support' }
      ],
      lifestyle: ['Multi-mask: clay on T-zone, cream on cheeks', 'Avoid alcohol-based toners', 'Minimal product layering', 'Patch test every new product'],
      ingredients: ['Niacinamide', 'Hyaluronic Acid', 'Ceramides', 'Allantoin', 'Centella Asiatica'],
      products: ['Derma Calm Gentle Cleanser', 'Acne & Scar Repair Serum', 'Barrier Repair Moisturizer', 'SPF 20 Hydrating Lotion', 'Under Eye Repair Serum']
    },
    P6: {
      id: 'P6',
      name: 'Barrier Damaged Skin',
      emoji: '🛡️',
      tagline: 'Rebuild, protect and restore your skin',
      tags: ['Damaged Barrier', 'Needs Repair', 'Reactive'],
      characteristics: 'Severely compromised skin barrier causing redness, flaking, stinging, and extreme sensitivity. Recovery-first approach.',
      morning: [
        { step: 1, action: 'Cleanse', product: 'Derma Calm Gentle Cleanser', why: 'The only cleanser safe for damaged barriers' },
        { step: 2, action: 'Serum', product: 'Barrier Repair Moisturizer (thin layer)', why: 'First layer of barrier restoration' },
        { step: 3, action: 'Moisturize', product: 'Barrier Repair Moisturizer', why: 'Rich ceramide-based repair' },
        { step: 4, action: 'SPF', product: 'SPF 20 Hydrating Lotion', why: 'UV radiation worsens barrier damage' }
      ],
      evening: [
        { step: 1, action: 'Cleanse', product: 'Derma Calm Gentle Cleanser', why: 'Never skip cleansing — buildup worsens damage' },
        { step: 2, action: 'Treatment', product: 'Barrier Repair Moisturizer (heavy layer)', why: 'Maximum overnight barrier repair' },
        { step: 3, action: 'Seal', product: 'Hand & Foot Repair Cream (face edges/dry patches)', why: 'Occlusive seal for worst affected areas' }
      ],
      lifestyle: ['Eliminate all active ingredients temporarily', 'Avoid fragrance, essential oils, exfoliants', 'Do not over-cleanse', 'Consult a dermatologist if no improvement in 3 weeks'],
      ingredients: ['Ceramides (1, 3, 6-II)', 'Cholesterol', 'Fatty Acids', 'Panthenol', 'Oat Extract', 'Allantoin'],
      products: ['Derma Calm Gentle Cleanser', 'Barrier Repair Moisturizer', 'SPF 20 Hydrating Lotion', 'Hand & Foot Repair Cream']
    },
    P7: {
      id: 'P7',
      name: 'Dehydrated Skin',
      emoji: '💦',
      tagline: 'Quench your skin from inside out',
      tags: ['Dehydrated', 'Dull', 'Needs Hydration'],
      characteristics: 'Skin lacking water (not oil). Can appear oily yet feel tight underneath. Dull, lackluster, fine lines from dehydration.',
      morning: [
        { step: 1, action: 'Cleanse', product: 'Hydrating Cream Cleanser', why: 'Adds hydration even during cleansing step' },
        { step: 2, action: 'Serum', product: 'Under Eye Repair Serum', why: 'High-water binding actives for radiance' },
        { step: 3, action: 'Moisturize', product: 'Barrier Repair Moisturizer', why: 'Lock in hydration from previous steps' },
        { step: 4, action: 'SPF', product: 'SPF 20 Hydrating Lotion', why: 'Hydrating SPF avoids further dehydration' }
      ],
      evening: [
        { step: 1, action: 'Cleanse', product: 'Hydrating Cream Cleanser', why: 'Cleanse without stripping hydration' },
        { step: 2, action: 'Serum', product: 'Timecode Anti-Ageing Serum', why: 'Stimulate collagen + intense overnight hydration' },
        { step: 3, action: 'Moisturize', product: 'Barrier Repair Moisturizer', why: 'Seal in overnight water replenishment' }
      ],
      lifestyle: ['Drink minimum 8 glasses of water daily', 'Apply products on damp skin', 'Avoid caffeine and alcohol in excess', 'Use a cool-mist humidifier at night'],
      ingredients: ['Hyaluronic Acid (multiple weights)', 'Glycerin', 'Beta-Glucan', 'Tremella Mushroom', 'Sodium PCA'],
      products: ['Hydrating Cream Cleanser', 'Under Eye Repair Serum', 'Barrier Repair Moisturizer', 'SPF 20 Hydrating Lotion', 'Timecode Anti-Ageing Serum']
    },
    P8: {
      id: 'P8',
      name: 'Normal & Balanced Skin',
      emoji: '✨',
      tagline: 'Maintain your natural perfection',
      tags: ['Normal', 'Balanced', 'Healthy'],
      characteristics: 'Well-balanced skin with minimal concerns. Focus is on maintenance, anti-ageing, and protection.',
      morning: [
        { step: 1, action: 'Cleanse', product: 'Derma Calm Gentle Cleanser', why: 'Gentle daily cleanse to maintain balance' },
        { step: 2, action: 'Serum', product: 'Timecode Anti-Ageing Serum', why: 'Preventative anti-ageing for long-term glow' },
        { step: 3, action: 'Moisturize', product: 'Barrier Repair Moisturizer', why: 'Maintain healthy barrier function' },
        { step: 4, action: 'SPF', product: 'Tinted Sunscreen SPF 50+', why: 'Broad spectrum protection for healthy skin' }
      ],
      evening: [
        { step: 1, action: 'Cleanse', product: 'Derma Calm Gentle Cleanser', why: 'Clean canvas for overnight repair' },
        { step: 2, action: 'Eye Care', product: 'Under Eye Repair Serum', why: 'Preventative eye area care' },
        { step: 3, action: 'Moisturize', product: 'Barrier Repair Moisturizer', why: 'Nightly repair and maintenance' }
      ],
      lifestyle: ['Sunscreen every day — your #1 anti-ageing tool', 'Stay consistent — results compound over time', 'Annual skin check with a dermatologist', 'Diet rich in antioxidants for lasting glow'],
      ingredients: ['Vitamin C', 'Retinol', 'Peptides', 'Antioxidants', 'SPF', 'Niacinamide'],
      products: ['Derma Calm Gentle Cleanser', 'Timecode Anti-Ageing Serum', 'Barrier Repair Moisturizer', 'Tinted Sunscreen SPF 50+', 'Under Eye Repair Serum']
    }
  };

  // ============================================================
  // PRODUCT CATALOG
  // ============================================================
  const PRODUCTS = {
    'Derma Calm Gentle Cleanser':     { variantId: 42977494335586, price: 179,  handle: 'derma-calm-gentle-cleanser', tag: 'Bestseller', image: 'https://cdn.shopify.com/s/files/1/0640/3109/6930/files/2_594f94dd-bff2-43b4-b542-4805f9ecd5ab.jpg' },
    'Salicylic + Glycolic Face Wash': { variantId: 42147361521762, price: 189,  handle: 'salicylic-glycolic-face-wash', tag: 'Acne Fighter', image: 'https://cdn.shopify.com/s/files/1/0640/3109/6930/files/1.png' },
    'Hydrating Cream Cleanser':       { variantId: 42839127654498, price: 189,  handle: 'hydrating-cream-cleanser', tag: 'Hydrating', image: 'https://cdn.shopify.com/s/files/1/0640/3109/6930/files/9.jpg' },
    'Timecode Anti-Ageing Serum':     { variantId: 42242952986722, price: 499,  handle: 'timecode-anti-ageing-serum', tag: 'Anti-Ageing', image: 'https://cdn.shopify.com/s/files/1/0640/3109/6930/files/1_b2973388-c196-4698-9070-7d371d2458f4.jpg' },
    'Acne & Scar Repair Serum':       { variantId: 42695914520674, price: 210,  handle: 'acne-scar-repair-serum', tag: 'Repair', image: 'https://cdn.shopify.com/s/files/1/0640/3109/6930/files/WhatsAppImage2026-04-05at18.36.05.jpg' },
    'Under Eye Repair Serum':         { variantId: 42304131596386, price: 405,  handle: 'under-eye-repair-serum', tag: 'Eye Care', image: 'https://cdn.shopify.com/s/files/1/0640/3109/6930/files/1_fc7d0b3d-776e-4181-b22e-ea1347feb6a7.jpg' },
    'Barrier Repair Moisturizer':     { variantId: 42418428936290, price: 220,  handle: 'barrier-repair-moisturizer', tag: 'Barrier Repair', image: 'https://cdn.shopify.com/s/files/1/0640/3109/6930/files/HIGH-CONCENTRATECLINICALCOMPLEXES_2.jpg' },
    'SPF 20 Hydrating Lotion':        { variantId: 42152128577634, price: 189,  handle: 'spf-20-hydrating-lotion', tag: 'Sun Protection', image: 'https://cdn.shopify.com/s/files/1/0640/3109/6930/files/Untitleddesign-2026-01-30T135250.196.jpg' },
    'Tinted Sunscreen SPF 50+':       { variantId: 42152125202530, price: 171,  handle: 'tinted-sunscreen-spf-50', tag: 'SPF 50+', image: 'https://cdn.shopify.com/s/files/1/0640/3109/6930/files/1_1.jpg' },
    'Hand & Foot Repair Cream':       { variantId: 42298202816610, price: 179,  handle: 'hand-foot-repair-cream', tag: 'Repair', image: 'https://cdn.shopify.com/s/files/1/0640/3109/6930/files/6.png' }
  };

  // ============================================================
  // STATE MANAGEMENT
  // ============================================================
  const STATE = {
    currentQ: 0,
    answers: [],
    profile: null,
    name: '',
    email: '',
    quizStartTime: null
  };

  // ============================================================
  // DOM HELPERS
  // ============================================================
  function $(sel) { return document.querySelector(sel); }
  function $$(sel) { return document.querySelectorAll(sel); }

  function showScreen(id) {
    $$('.bq-screen').forEach(s => s.classList.remove('active'));
    const target = document.getElementById(id);
    if (target) {
      target.classList.add('active');
      target.scrollIntoView({behavior: 'smooth', block: 'start'});
    }
  }

  function updateProgress() {
    const pct = Math.round((STATE.currentQ / QUESTIONS.length) * 100);
    const bar = $('.bq-progress-fill');
    const text = $('.bq-progress-text');
    if (bar) bar.style.width = pct + '%';
    if (text) text.textContent = 'Question ' + (STATE.currentQ + 1) + ' of ' + QUESTIONS.length;
  }

  function showToast(msg, type) {
    const toast = document.createElement('div');
    toast.className = 'bq-toast bq-toast-' + (type || 'success');
    toast.textContent = msg;
    document.body.appendChild(toast);
    setTimeout(() => toast.classList.add('show'), 10);
    setTimeout(() => { toast.classList.remove('show'); setTimeout(() => toast.remove(), 300); }, 3000);
  }

  // ============================================================
  // QUESTION RENDERER
  // ============================================================
  function renderQuestion(index) {
    const q = QUESTIONS[index];
    if (!q) return;
    const container = $('#bq-question-body');
    if (!container) return;

    container.innerHTML = '';
    const wrap = document.createElement('div');
    wrap.className = 'bq-question-wrap animate-in';

    const qNum = document.createElement('div');
    qNum.className = 'bq-q-number';
    qNum.textContent = 'Question ' + (index + 1);

    const qText = document.createElement('h2');
    qText.className = 'bq-q-text';
    qText.textContent = q.text;

    const optsDiv = document.createElement('div');
    optsDiv.className = 'bq-options';

    q.opts.forEach((opt, i) => {
      const btn = document.createElement('button');
      btn.className = 'bq-option';
      btn.textContent = opt.text;
      btn.setAttribute('data-index', i);
      btn.addEventListener('click', () => selectOption(btn, opt, index));
      optsDiv.appendChild(btn);
    });

    wrap.appendChild(qNum);
    wrap.appendChild(qText);
    wrap.appendChild(optsDiv);
    container.appendChild(wrap);

    updateProgress();

    // Navigation buttons
    const prevBtn = $('#bq-prev-btn');
    const nextBtn = $('#bq-next-btn');
    if (prevBtn) prevBtn.style.display = index === 0 ? 'none' : 'inline-flex';
    if (nextBtn) nextBtn.textContent = index === QUESTIONS.length - 1 ? 'See My Results' : 'Next Question';

    // Restore previous answer if navigating back
    if (STATE.answers[index]) {
      const saved = STATE.answers[index];
      $$('.bq-option').forEach(btn => {
        if (btn.textContent === saved.text) {
          btn.classList.add('selected');
        }
      });
    }
  }

  function selectOption(btn, opt, qIndex) {
    $$('.bq-option').forEach(b => b.classList.remove('selected'));
    btn.classList.add('selected');
    STATE.answers[qIndex] = { text: opt.text, scores: opt.scores };

    // Auto-advance after short delay
    setTimeout(() => {
      if (qIndex < QUESTIONS.length - 1) {
        STATE.currentQ++;
        renderQuestion(STATE.currentQ);
      } else {
        // Last question — go to lead capture
        showScreen('bq-lead-screen');
      }
    }, 400);
  }

  // ============================================================
  // NAVIGATION
  // ============================================================
  function prevQuestion() {
    if (STATE.currentQ > 0) {
      STATE.currentQ--;
      renderQuestion(STATE.currentQ);
    }
  }

  function nextQuestion() {
    if (!STATE.answers[STATE.currentQ]) {
      showToast('Please select an answer to continue', 'warning');
      return;
    }
    if (STATE.currentQ < QUESTIONS.length - 1) {
      STATE.currentQ++;
      renderQuestion(STATE.currentQ);
    } else {
      showScreen('bq-lead-screen');
    }
  }

  // ============================================================
  // RESULTS RENDERER
  // ============================================================
  function renderResults() {
    const scores = calculateScores(STATE.answers.filter(Boolean));
    const profileId = determineProfile(scores);
    const profile = PROFILES[profileId];
    STATE.profile = profile;

    // Profile header
    const nameEl = $('#bq-profile-name');
    const taglineEl = $('#bq-profile-tagline');
    const emojiEl = $('#bq-profile-emoji');
    const tagsEl = $('#bq-profile-tags');
    const charEl = $('#bq-profile-char');

    if (nameEl) nameEl.textContent = profile.name;
    if (taglineEl) taglineEl.textContent = profile.tagline;
    if (emojiEl) emojiEl.textContent = profile.emoji;
    if (charEl) charEl.textContent = profile.characteristics;
    if (tagsEl) {
      tagsEl.innerHTML = '';
      profile.tags.forEach(t => {
        const span = document.createElement('span');
        span.className = 'bq-tag';
        span.textContent = t;
        tagsEl.appendChild(span);
      });
    }

    // Skin scores summary
    const summaryEl = $('#bq-scores-summary');
    if (summaryEl) {
      summaryEl.innerHTML = '<div class="bq-score-item"><span>Skin Type</span><strong>' + scores.st.charAt(0).toUpperCase() + scores.st.slice(1) + '</strong></div>' +
        '<div class="bq-score-item"><span>Sensitivity</span><strong>' + (scores.ss === 'mod' ? 'Moderate' : scores.ss.charAt(0).toUpperCase() + scores.ss.slice(1)) + '</strong></div>' +
        '<div class="bq-score-item"><span>Barrier</span><strong>' + scores.bh.charAt(0).toUpperCase() + scores.bh.slice(1) + '</strong></div>' +
        '<div class="bq-score-item"><span>Hydration</span><strong>' + (scores.hl === 'mod' ? 'Moderate' : scores.hl.charAt(0).toUpperCase() + scores.hl.slice(1)) + '</strong></div>' +
        '<div class="bq-score-item"><span>Texture</span><strong>' + (scores.tx === 'mild' ? 'Mildly Uneven' : scores.tx.charAt(0).toUpperCase() + scores.tx.slice(1)) + '</strong></div>';
    }

    // Morning routine
    renderRoutine('#bq-morning-routine', profile.morning);

    // Evening routine
    renderRoutine('#bq-evening-routine', profile.evening);

    // Lifestyle tips
    const lifestyleEl = $('#bq-lifestyle-tips');
    if (lifestyleEl) {
      lifestyleEl.innerHTML = profile.lifestyle.map(tip =>
        '<li class="bq-tip"><span class="bq-tip-icon">✓</span>' + tip + '</li>'
      ).join('');
    }

    // Product recommendations
    renderProducts(profile);
  }

  function renderRoutine(selector, routine) {
    const el = document.querySelector(selector);
    if (!el) return;
    el.innerHTML = routine.map(step =>
      '<div class="bq-routine-step"><div class="bq-step-num">' + step.step + '</div>' +
      '<div class="bq-step-info"><div class="bq-step-action">' + step.action + '</div>' +
      '<div class="bq-step-product">' + step.product + '</div>' +
      '<div class="bq-step-why">' + step.why + '</div></div></div>'
    ).join('');
  }

  function renderProducts(profile) {
    const grid = $('#bq-products-grid');
    if (!grid) return;
    grid.innerHTML = '';

    profile.products.forEach(pName => {
      const p = PRODUCTS[pName];
      if (!p) return;

      const card = document.createElement('div');
      card.className = 'bq-product-card';
      card.innerHTML =
        '<div class="bq-product-tag">' + p.tag + '</div>' +
        '<div class="bq-product-img-wrap">' +
          '<img src="' + (p.image || '') + '" alt="' + pName + '" class="bq-product-img" loading="lazy" ' +
          'onerror="this.style.display=\'none\'" />' +
        '</div>' +
        '<div class="bq-product-info">' +
          '<h4 class="bq-product-name">' + pName + '</h4>' +
          '<div class="bq-product-price">₹' + p.price + '</div>' +
          '<button class="bq-add-to-cart" data-variant="' + p.variantId + '" data-name="' + pName + '">' +
            'Add to Cart' +
          '</button>' +
        '</div>';

      grid.appendChild(card);
    });

    // Attach add to cart listeners
    $$('.bq-add-to-cart').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const variantId = e.currentTarget.getAttribute('data-variant');
        const name = e.currentTarget.getAttribute('data-name');
        addToCart(variantId, name, e.currentTarget);
      });
    });
  }

  // ============================================================
  // SHOPIFY AJAX ADD TO CART
  // ============================================================
  function addToCart(variantId, productName, btn) {
    const original = btn.textContent;
    btn.textContent = 'Adding...';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
    })
    .then(r => r.json())
    .then(data => {
      if (data.id) {
        btn.textContent = '✓ Added!';
        btn.classList.add('added');
        showToast(productName + ' added to cart!', 'success');
        // Update cart count if element exists
        fetch('/cart.js').then(r => r.json()).then(cart => {
          const countEl = document.querySelector('.cart-count-bubble span, [data-cart-count]');
          if (countEl) countEl.textContent = cart.item_count;
        });
        setTimeout(() => { btn.textContent = original; btn.disabled = false; btn.classList.remove('added'); }, 2500);
      } else {
        throw new Error(data.description || 'Could not add to cart');
      }
    })
    .catch(err => {
      btn.textContent = 'Error';
      showToast('Could not add to cart. Please try again.', 'error');
      setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 2000);
    });
  }

  // ============================================================
  // LEAD CAPTURE
  // ============================================================
  function handleLeadCapture(e) {
    e.preventDefault();

    const nameInput = $('#bq-name-input');
    const emailInput = $('#bq-email-input');
    const nameErrorEl = $('#bq-name-error');
    const emailErrorEl = $('#bq-email-error');

    if (nameErrorEl) nameErrorEl.textContent = '';
    if (emailErrorEl) emailErrorEl.textContent = '';

    const name = nameInput ? nameInput.value.trim() : '';
    const email = emailInput ? emailInput.value.trim() : '';

    if (!name) {
      if (nameErrorEl) nameErrorEl.textContent = 'Please enter your full name.';
      showToast('Please enter your full name to continue', 'warning');
      if (nameInput) nameInput.focus();
      return;
    }

    if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      if (emailErrorEl) emailErrorEl.textContent = 'Please enter a valid email address.';
      showToast('Please enter a valid email address', 'warning');
      if (emailInput) emailInput.focus();
      return;
    }

    // Save to localStorage
    try {
      localStorage.setItem('bq_user_name', name);
      localStorage.setItem('bq_user_email', email);
    } catch (ex) {}

    // Save to STATE
    STATE.name = name;
    STATE.email = email;
    saveShopifyCustomer(name, email, STATE.profile);
    showLoadingScreen();
  }

  function saveShopifyCustomer(fullName, email, profile) {
    try {
      if (!email) return;
      var parts = (fullName || '').trim().split(/\s+/);
      var firstName = parts.shift() || '';
      var lastName  = parts.join(' ') || '';
      var tags = ['skin-analysis-lead'];
      if (profile && profile.name) {
        var slug = profile.name.toLowerCase()
          .replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
        if (slug) tags.push('skin-profile-' + slug);
      }
      var body = new URLSearchParams();
      body.append('form_type', 'customer');
      body.append('utf8', '\u2713');
      body.append('contact[email]', email);
      body.append('contact[first_name]', firstName);
      body.append('contact[last_name]', lastName);
      body.append('contact[tags]', tags.join(','));
      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
        keepalive: true
      }).catch(function (err) {
        console.warn('[BQ lead capture] customer save failed, continuing to report:', err);
      });
    } catch (err) {
      console.warn('[BQ lead capture] unexpected error, continuing to report:', err);
    }
  }

  // ============================================================
  // LOADING SCREEN
  // ============================================================
  function showLoadingScreen() {
    showScreen('bq-loading-screen');
    const msgs = [
      'Analyzing your skin profile...',
      'Matching BERLYNCO formulas...',
      'Building your routine...',
      'Preparing recommendations...',
      'Almost ready...'
    ];
    let i = 0;
    const msgEl = $('#bq-loading-msg');
    const interval = setInterval(() => {
      if (msgEl && i < msgs.length) { msgEl.textContent = msgs[i]; i++; }
    }, 700);
    const loadBar = $('#bq-load-bar');
    if (loadBar) { loadBar.style.width = '0%'; setTimeout(() => { loadBar.style.transition = 'width 3.5s ease'; loadBar.style.width = '100%'; }, 50); }
    setTimeout(() => { clearInterval(interval); renderResults(); showScreen('bq-results-screen'); }, 3600);
  }

  // ============================================================
  // QUIZ START
  // ============================================================
  function startQuiz() {
    STATE.currentQ = 0;
    STATE.answers = [];
    STATE.quizStartTime = Date.now();
    showScreen('bq-quiz-screen');
    renderQuestion(0);
    // Extension: track quiz start
    // BQ_EXTENSION.onQuizStart({ time: STATE.quizStartTime });
  }

  function restartQuiz() {
    STATE.currentQ = 0;
    STATE.answers = [];
    STATE.profile = null;
    STATE.name = '';
    STATE.email = '';
    showScreen('bq-intro-screen');
  }

  // ============================================================
  // EVENT LISTENERS
  // ============================================================
  function initEventListeners() {
    // Start quiz
    const startBtn = $('#bq-start-btn');
    if (startBtn) startBtn.addEventListener('click', startQuiz);

    // Navigation
    const prevBtn = $('#bq-prev-btn');
    if (prevBtn) prevBtn.addEventListener('click', prevQuestion);
    const nextBtn = $('#bq-next-btn');
    if (nextBtn) nextBtn.addEventListener('click', nextQuestion);

    // Lead form
    const leadForm = $('#bq-lead-form');
    if (leadForm) leadForm.addEventListener('submit', handleLeadCapture);
    // Restart
    const restartBtn = $('#bq-restart-btn');
    if (restartBtn) restartBtn.addEventListener('click', restartQuiz);

    // Share results
    const shareBtn = $('#bq-share-btn');
    if (shareBtn) shareBtn.addEventListener('click', () => {
      if (navigator.share) {
        navigator.share({ title: 'My BERLYNCO Skin Profile', text: 'I just found my perfect skincare routine!', url: window.location.href });
      } else {
        navigator.clipboard.writeText(window.location.href);
        showToast('Link copied to clipboard!', 'success');
      }
    });
  }

  // ============================================================
  // INIT
  // ============================================================
  function init() {
    initEventListeners();
    showScreen('bq-intro-screen');
    console.log('[BERLYNCO Quiz] Initialized v2.0');
    // Extension point hooks (implement separately)
    // BQ_EXTENSION = { onQuizStart: ()=>{}, onLeadCapture: ()=>{}, onProfileGenerated: ()=>{}, onAbandon: ()=>{} };
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();